import { useMutation } from '@tanstack/react-query';
import { getSharedVideoPresignedUrl } from '../services';

export default function useGetSharedVideoPresignedUrl() {
  return useMutation(getSharedVideoPresignedUrl, { onSuccess: (data) => data });
}
